import React, { PropTypes } from "react";
import ReactDOM from "react-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { FormattedMessage } from "react-intl";

import { RectangleSpinner } from "../../../../../common/spinners";
import FollowUpComment from "./FollowUpComment";

class FollowUpCommentsList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      boxHeight: 0,
      listHeight: 0,
    };
  }

  componentDidMount() {
    this._calculateHeight();
  }

  componentDidUpdate() {
    if (!this.refs["comments"]) {
      return;
    }

    const { listHeight } = this.state;
    const newListHeight = ReactDOM.findDOMNode(this.refs["comments"])
      .offsetHeight;

    if (listHeight !== newListHeight) {
      this._calculateHeight(newListHeight);
    }
  }

  _calculateHeight(newListHeight = null) {
    if (!this.refs["comments"]) {
      return;
    }

    const { generateFollowUp } = this.props;
    const maximumHeight = generateFollowUp ? 690 : 330;
    const minimumHeight = 62;
    const boxPadding = 37;

    const listHeight =
      newListHeight || ReactDOM.findDOMNode(this.refs["comments"]).offsetHeight;
    const boxHeight = Math.max(
      minimumHeight,
      Math.min(maximumHeight, listHeight + boxPadding)
    );

    this.setState({ boxHeight, listHeight });
  }

  render() {
    const { boxHeight } = this.state;
    const { comments, ...rest } = this.props;

    const style = { height: boxHeight + "px" };

    return (
      <div className="follow-up-comment-list" style={style}>
        {(comments == null && (
          <div ref="comments">
            <RectangleSpinner />
          </div>
        )) ||
          (!!comments && comments.length == 0 && (
            <p ref="comments" className="empty-comment-list">
              <FormattedMessage id="members.followUps.form.comments.commentListEmpty" />
            </p>
          )) || (
            <Scrollbars
              autoHide={false}
              renderThumbVertical={({ ...props }) => (
                <div {...props} className="scrollbars" />
              )}
              renderView={({ ...props }) => (
                <div {...props} className="scrollarea" />
              )}
            >
              <div ref="comments">
                {comments.map((comment, i) => (
                  <FollowUpComment readOnly={this.props.readOnly} key={i} comment={comment} {...rest} />
                ))}
              </div>
            </Scrollbars>
          )}
      </div>
    );
  }
}

FollowUpCommentsList.propTypes = {
  comments: PropTypes.array,
  generateFollowUp: PropTypes.bool,
  readOnly: PropTypes.bool
};

export default FollowUpCommentsList;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/comments/FollowUpCommentsList.js